import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "draivn-help-center-demo-modal drv-mt-4" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "drv-text-heading-h4 drv-mb-3" }
const _hoisted_5 = { class: "drv-text-body-md drv-color-n700 drv-mb-4" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "actions row drv-mt-6" }
const _hoisted_8 = { class: "action" }
const _hoisted_9 = { class: "action cancel" }

import { computed, ref } from "vue";
import { EMessagesKeys, type IDemoRequest } from "../../types";
import DemoForm from "./DemoForm.vue";
import { useDialogPluginComponent } from "draivn-ui-kit";


export default /*@__PURE__*/_defineComponent({
  __name: 'DemoDialog',
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {



const demoModel = ref<IDemoRequest | null>(null);
const demoControl = ref<typeof DemoForm | null>(null);

const hasError = computed<boolean>(() => {
  return demoControl.value?.hasError ?? false;
});

const { dialogRef, onDialogCancel, onDialogOK, onDialogHide } =
  useDialogPluginComponent();

const onSubmit = () => {
  onDialogOK(demoModel.value);
};

return (_ctx: any,_cache: any) => {
  const _component_d_icon = _resolveComponent("d-icon")!
  const _component_d_btn = _resolveComponent("d-btn")!
  const _component_d_dialog = _resolveComponent("d-dialog")!

  return (_openBlock(), _createBlock(_component_d_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    "no-esc-dismiss": "",
    "no-backdrop-dismiss": "",
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_TITLE)), 1),
            _createVNode(_component_d_btn, { onClick: _unref(onDialogCancel) }, {
              default: _withCtx(() => [
                _createVNode(_component_d_icon, {
                  name: "cross",
                  size: 20,
                  color: "n900",
                  onClick: _unref(onDialogCancel)
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_SUBTITLE)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(DemoForm, {
            ref_key: "demoControl",
            ref: demoControl,
            modelValue: demoModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((demoModel).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_d_btn, {
              label: _ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_SUBMIT_TITLE),
              onClick: onSubmit,
              disable: hasError.value
            }, null, 8, ["label", "disable"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_d_btn, {
              label: _ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_CANCEL_TITLE),
              onClick: _unref(onDialogCancel),
              variant: "secondary"
            }, null, 8, ["label", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})